import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import React from 'react';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const StripeEmbeddedCheckout = ({
  clientSecret,
}) => {

  if(!clientSecret) {
    return null
  }


  const options = {
    clientSecret: clientSecret,
  }
  
  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

export default StripeEmbeddedCheckout;